import { render, staticRenderFns } from "./ValSetBox.vue?vue&type=template&id=45c7d618&scoped=true"
import script from "./ValSetBox.vue?vue&type=script&lang=js"
export * from "./ValSetBox.vue?vue&type=script&lang=js"
import style0 from "./ValSetBox.vue?vue&type=style&index=0&id=45c7d618&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c7d618",
  null
  
)

export default component.exports